import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type Role = 'SUPER_ADMIN' | 'TENANT_ADMIN' | 'MANAGER' | 'AGENT' | 'READ_ONLY'

export interface AuthUser {
  id: string
  tenantId: string
  email: string
  firstName: string
  lastName: string
  role: Role
  locale: string
}

interface AuthState {
  user: AuthUser | null
  tenantSlug: string | null
  accessToken: string | null
  refreshToken: string | null
  setSession: (s: { user: AuthUser; tenantSlug: string; accessToken: string; refreshToken: string }) => void
  setTokens: (accessToken: string, refreshToken: string) => void
  setTenantSlug: (slug: string) => void
  clear: () => void
}

// Persist tenantSlug + tokens to survive refresh. We deliberately keep the
// JWT access token in memory + localStorage for v1; moving to an httpOnly
// cookie is a Sprint 8 follow-up when we add CSRF.
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      tenantSlug: null,
      accessToken: null,
      refreshToken: null,
      setSession: (s) => set({ user: s.user, tenantSlug: s.tenantSlug, accessToken: s.accessToken, refreshToken: s.refreshToken }),
      setTokens: (accessToken, refreshToken) => set({ accessToken, refreshToken }),
      setTenantSlug: (tenantSlug) => set({ tenantSlug }),
      clear: () => set({ user: null, tenantSlug: null, accessToken: null, refreshToken: null }),
    }),
    { name: 'vela.auth' },
  ),
)
